import Button from "@mui/material/Button";
import DescriptionIcon from "@mui/icons-material/Description";
import { useMemo, useRef } from "react";
import { useFormContext } from "react-hook-form";

const Index = () => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const { getValues } = useFormContext();
  const dokumentOIskljucenju = getValues("dokumentOIskljucenju");

  const url = useMemo(() => {
    if (!dokumentOIskljucenju || linkRef.current === null) return "/";

    linkRef.current.download = "Dokument o iskljucenju.pdf";
    return `data:application/pdf;base64,${dokumentOIskljucenju}`;
  }, [dokumentOIskljucenju, linkRef.current]);

  return (
    <div>
      <h5>Dokaz o isključenosti operatera</h5>
      <Button
        variant="outlined"
        endIcon={<DescriptionIcon />}
        href={url}
        ref={linkRef}
      >
        Dokument o isključenju (Exclusion document)
      </Button>
    </div>
  );
};

export default Index;
